export default __webpack_public_path__ + "static/media/cidade.c7f79644.png";